import { agentStudioRouteEntry } from '@atlassian/jira-router-routes-agent-studio-entries/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const supportCenterSettingRouteEntries: Route[] = [agentStudioRouteEntry];
